// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lib-richtext {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  -webkit-flex: 0 1 auto;
          flex: 0 1 auto;
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin-bottom: 4px;
  margin-top: 4px;
}
.lib-richtext.lib-richtext-designer .tox-tinymce {
  pointer-events: none;
}
.lib-richtext .tox-tinymce {
  -webkit-flex: 1 1;
          flex: 1 1;
}
.lib-richtext .lib-richtext-label {
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 13px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  color: #333;
  -webkit-justify-content: flex-end;
          justify-content: flex-end;
  -webkit-align-self: flex-start;
          align-self: flex-start;
  line-height: 20px;
  padding-right: 8px;
  text-align: right;
  width: 110px;
  min-height: 20px;
}
.lib-richtext .lib-richtext-label .required-star {
  color: red;
  font-size: 16px;
  padding: 0;
  font-style: normal;
  -webkit-transform: scale(0.5);
          transform: scale(0.5);
}
.lib-richtext .lib-richtext-content {
  display: -webkit-flex;
  display: flex;
  -webkit-flex: 1 1;
          flex: 1 1;
  height: 100%;
}
.lib-richtext .lib-richtext-content .tox .tox-tbtn {
  font-size: 14px;
}
.lib-richtext .lib-richtext-content-readonly {
  word-break: break-word;
  max-height: 100%;
  overflow: auto;
  width: 100%;
}
.lib-richtext .horizontally {
  -webkit-justify-content: center;
          justify-content: center;
  text-align: center;
}
.lib-richtext .verticalCenter {
  -webkit-align-items: center;
          align-items: center;
}
.lib-richtext-vertical {
  -webkit-flex-direction: column;
          flex-direction: column;
}
.lib-richtext-vertical .lib-richtext-label {
  width: initial;
}
.lib-richtext-vertical .lib-richtext-content {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/RichText/style/index.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,sBAAA;UAAA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EAEI,oBAAA;AAAN;AAZA;EAgBI,iBAAA;UAAA,SAAA;AADJ;AAfA;EAmBI,qBAAA;EAAA,aAAA;EACA,4BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,iCAAA;UAAA,yBAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAjCA;EAoCM,UAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;UAAA,qBAAA;AAAN;AAxCA;EA4CI,qBAAA;EAAA,aAAA;EACA,iBAAA;UAAA,SAAA;EACA,YAAA;AADJ;AA7CA;EAiDM,eAAA;AADN;AAhDA;EAsDI,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAHJ;AAtDA;EA4DI,+BAAA;UAAA,uBAAA;EACA,kBAAA;AAHJ;AA1DA;EAgEI,2BAAA;UAAA,mBAAA;AAHJ;AAOA;EACE,8BAAA;UAAA,sBAAA;AALF;AAIA;EAGI,cAAA;AAJJ;AACA;EAMI,WAAA;AAJJ","sourcesContent":[".lib-richtext {\n  display: flex;\n  align-items: center;\n  flex: 0 1 auto;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  margin-bottom: 4px;\n  margin-top: 4px;\n  // min-height: 400px;\n  &.lib-richtext-designer {\n    .tox-tinymce {\n      pointer-events: none;\n    }\n  }\n  .tox-tinymce {\n    flex: 1;\n  }\n  .lib-richtext-label {\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    font-size: 13px;\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: break-all;\n    color: #333;\n    justify-content: flex-end;\n    align-self: flex-start;\n    line-height: 20px;\n    padding-right: 8px;\n    text-align: right;\n    width: 110px;\n    min-height: 20px;\n    .required-star {\n      color: red;\n      font-size: 16px;\n      padding: 0;\n      font-style: normal;\n      transform: scale(0.5);\n    }\n  }\n  .lib-richtext-content {\n    display: flex;\n    flex: 1;\n    height: 100%;\n    \n    .tox .tox-tbtn {\n      font-size: 14px;\n    }\n  }\n\n  .lib-richtext-content-readonly {\n    word-break: break-word;\n    max-height: 100%;\n    overflow: auto;\n    width: 100%;\n  }\n  .horizontally {\n    justify-content: center;\n    text-align: center;\n  }\n  .verticalCenter {\n    align-items: center;\n  }\n}\n\n.lib-richtext-vertical {\n  flex-direction: column;\n  .lib-richtext-label {\n    width: initial;\n  }\n  .lib-richtext-content {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
